import { formatLocalDateTime } from "../../utils/dateTime";

export function formatArchivedAt(value, timeZone) {
    return formatLocalDateTime(value, timeZone);
}

export function filterArchivedTags(rows, { query = "", serverId = "all" } = {}) {
    const text = String(query || "").trim().toLowerCase();
    return (Array.isArray(rows) ? rows : []).filter((row) => {
        if (serverId && serverId !== "all" && String(row.server) !== String(serverId)) {
            return false;
        }
        if (!text) {
            return true;
        }
        return `${row.name || ""} ${row.node_id || ""}`.toLowerCase().includes(text);
    });
}

export function sortArchivedTags(rows, direction = "desc") {
    const factor = direction === "asc" ? 1 : -1;
    return [...(Array.isArray(rows) ? rows : [])].sort((left, right) => {
        const leftTime = Date.parse(left.archived_at || "") || 0;
        const rightTime = Date.parse(right.archived_at || "") || 0;
        if (leftTime !== rightTime) {
            return (leftTime - rightTime) * factor;
        }
        return String(left.name || "").localeCompare(String(right.name || ""));
    });
}

export function confirmationMatches(tag, typedName, typedId) {
    if (!tag) {
        return false;
    }
    return typedName === tag.name && String(typedId) === String(tag.id);
}
